import {
  LIST_DOCUMENT_CLASSIFICATION_REQUEST,
  LIST_DOCUMENT_CLASSIFICATION_SUCCESS,
  LIST_DOCUMENT_CLASSIFICATION_FAIL,
  DETAIL_DOCUMENT_CLASSIFICATION_REQUEST,
  DETAIL_DOCUMENT_CLASSIFICATION_SUCCESS,
  DETAIL_DOCUMENT_CLASSIFICATION_FAIL,
  CREATE_DOCUMENT_CLASSIFICATION_REQUEST,
  CREATE_DOCUMENT_CLASSIFICATION_SUCCESS,
  CREATE_DOCUMENT_CLASSIFICATION_FAIL,
  UPDATE_DOCUMENT_CLASSIFICATION_REQUEST,
  UPDATE_DOCUMENT_CLASSIFICATION_SUCCESS,
  UPDATE_DOCUMENT_CLASSIFICATION_FAIL,
  DELETE_DOCUMENT_CLASSIFICATION_REQUEST,
  DELETE_DOCUMENT_CLASSIFICATION_SUCCESS,
  DELETE_DOCUMENT_CLASSIFICATION_FAIL,
  LIST_DOCUMENT_CLASSIFICATION_SUMMARY_REQUEST,
  LIST_DOCUMENT_CLASSIFICATION_SUMMARY_SUCCESS,
  LIST_DOCUMENT_CLASSIFICATION_SUMMARY_FAIL
} from '../../constants/document-classifications'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingDetail: false,
  loadingUpdate: false,
  loadingDelete: false,
  documentClassifications: [],
  documentClassificationSummaries: [],
  documentClassification: {},
  error: null,
  pageable: {}
}

const documentClassificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_DOCUMENT_CLASSIFICATION_REQUEST:
      return { ...state, loading: true }
    case LIST_DOCUMENT_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        documentClassifications: action.payload,
        pageable: action.pageable
      }
    case LIST_DOCUMENT_CLASSIFICATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        documentClassifications: []
      }

    case LIST_DOCUMENT_CLASSIFICATION_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_DOCUMENT_CLASSIFICATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        documentClassificationSummaries: action.payload
      }
    case LIST_DOCUMENT_CLASSIFICATION_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        documentClassificationSummaries: []
      }

    case CREATE_DOCUMENT_CLASSIFICATION_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_DOCUMENT_CLASSIFICATION_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_DOCUMENT_CLASSIFICATION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }

    case DETAIL_DOCUMENT_CLASSIFICATION_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_DOCUMENT_CLASSIFICATION_SUCCESS:
      return { ...state, loadingDetail: false, documentClassification: action.payload }
    case DETAIL_DOCUMENT_CLASSIFICATION_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }

    case UPDATE_DOCUMENT_CLASSIFICATION_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_DOCUMENT_CLASSIFICATION_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_DOCUMENT_CLASSIFICATION_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }

    case DELETE_DOCUMENT_CLASSIFICATION_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_DOCUMENT_CLASSIFICATION_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_DOCUMENT_CLASSIFICATION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }

    default:
      return state
  }
}

export default documentClassificationsReducer
